import styled from "@emotion/styled";

import { theme } from "../../../../../../Controls/Internals/ThemeProvider/CandyTheme/ThemeShorthand";

interface RootProps {
    visible: boolean;
}

export const StepPage = styled.div<RootProps>(props => ({
    ...theme(props).typography.primary.css(),
    display: props.visible ? "block" : "none",
}));

export const VisibleModal = styled.div<RootProps>(props => ({
    ...theme(props).typography.primary.css(),
    display: props.visible ? "block" : "none",
}));

export const CombineMethodPickerContainer = styled.div(props => ({
    paddingBottom: theme(props).size(4),
}));

export const CombineMethodWrapper = styled.div(props => ({
    ...theme(props).typography.primary.css(),
    display: "flex",
    padding: `${theme(props).size(2)} ${theme(props).size(1.5)}`,
    borderRadius: theme(props).size(1),
    border: `1px solid ${props.theme.candy.patchFufCombineMethods.border}`,
    transition: "background 0.2s ease",
    ":hover": {
        cursor: "pointer",
        backgroundColor: props.theme.candy.patchFufCombineMethods.hoveredBackgroundColor,
    },
}));

export const OptionIcon = styled.div(props => ({
    marginTop: theme(props).size(0.5),
    marginRight: theme(props).size(1.5),
}));

export const OptionTitle = styled.div({
    fontWeight: "bold",
});

export const OptionDescription = styled.div(props => ({
    ...theme(props).typography.smallFont.css(),
}));

export const ModalText = styled.div(props => ({
    marginBottom: theme(props).size(2),
    fontSize: "16px",
}));
